import { Category, GradeLevel, Platform, Subject, Technology } from 'models';
import Approval from 'models/Approval';
import Lesson from 'models/Lesson';

export interface Filter {
  isMultivalue?: boolean;
  model: any;
  name: keyof Lesson;
}

export interface Filters {
  gradeLevel: Filter;
  subject: Filter;
  category: Filter;
  platform: Filter;
  technology: Filter;
  approval: Filter;
}

export const filters: Filters = {
  gradeLevel: {
    isMultivalue: true,
    model: GradeLevel,
    name: 'gradeLevels',
  },
  subject: {
    model: Subject,
    name: 'subjectAreas',
  },
  category: {
    model: Category,
    name: 'categories',
  },
  platform: {
    model: Platform,
    name: 'platforms',
  },
  technology: {
    model: Technology,
    name: 'technologies',
  },
  approval: {
    model: Approval,
    name: 'submissionApproved',
  },
};
